<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11.1606 32.2188C17.3 38.9425 25 43.9062 25 43.9062C25 43.9062 46.3125 30.1562 46.3125 17.4375C46.3125 11.1744 41.2319 6.09375 34.9688 6.09375C30.665 6.09375 27.0625 8.15625 25 11.5938C22.9375 8.15625 19.335 6.09375 15.0312 6.09375C8.76813 6.09375 3.6875 11.1744 3.6875 17.4375C3.6875 21.0194 5.37875 24.6769 7.80562 28.0938"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M3.6875 28.0938H14L16.0625 24.6562L19.5 31.5312L25 17.0938L29.125 28.0938H34.625"
			:stroke="props.iconColor"
			stroke-width="1.6"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
